package geometry

import com.github.chosamuel.kishibe.math.Vector2
import math.lerp
import kotlin.math.PI
import kotlin.math.cos
import kotlin.math.sin

open class Crescent(
    val center: Vector2,
    val radius: Double,
    val resolution:Int = 180,
) {
    var stage = 1.0 //fully open
    var rotation = 0.0
    fun getVertices(): List<MutableList<Vector2>> {
        val lowerPoints = mutableListOf<Vector2>()
        val upperPoints = mutableListOf<Vector2>()
        val step = PI / (resolution - 1.0)
        repeat(resolution){
            val theta = it*step
            val p1 = Vector2(cos(theta + rotation), sin(theta + rotation))
                .times(radius)
                .plus(center)
            val p2 = Vector2(cos(-theta+rotation), sin(-theta+rotation))
                .times(radius)
                .plus(center)
            val px = p2.lerp(p1,stage)

            lowerPoints.add(p1)
            upperPoints.add(px)
        }
        return listOf(lowerPoints,upperPoints)
    }
}

